<div class="alert alert-warning text-center mt-5">
    <h1>Cargando</h1>
    <i class="fas fa-sync-alt fa-5x fa-spin mt-5"></i>
    <p class="mt-5">
        Espere...
    </p>
</div>